import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceProduct } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchServiceProduct, FindServiceProduct } from './interface';

export const findServiceProduct = createAsyncThunk(
  'serviceProduct/find',
  async (values: FindServiceProduct, { rejectWithValue }) => {
    try {
      return await ServiceProduct.find({ query: values });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getServiceProduct = createAsyncThunk(
  'serviceProduct/get',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await ServiceProduct.get(id);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createServiceProduct = createAsyncThunk(
  'serviceProduct/create',
  async (values: CreatePatchServiceProduct, { rejectWithValue }) => {
    try {
      return await ServiceProduct.create(values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchServiceProduct = createAsyncThunk(
  'serviceProduct/patch',
  async ({ id, ...values }: CreatePatchServiceProduct, { rejectWithValue }) => {
    try {
      return await ServiceProduct.patch(id, values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
